export default __webpack_public_path__ + "static/media/logo-us-mac.ffc2cdbd.svg";